import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { SiteNavFullWidthDropdownContent } from './SiteNavFullWidthDropdownContent';
import { SiteNavPartialWidthDropdownContent } from './SiteNavPartialWidthDropdownContent';

const SiteNavDropdownContent = ({
    items: moduleItems,
    trackingLabelPrefix,
    showFullWidthNav,
    navigationModule,
}) => {
    const navProps = { moduleItems, trackingLabelPrefix };

    if (showFullWidthNav) {
        // Full-width nav
        return (
            <SiteNavFullWidthDropdownContent {...navProps} navigationModule={navigationModule} />
        );
    } else {
        // Original partial width nav
        return <SiteNavPartialWidthDropdownContent {...navProps} />;
    }
};

SiteNavDropdownContent.propTypes = {
    items: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
    showFullWidthNav: PropTypes.bool,
    navigationModule: PropTypes.object,
};

export default createFragmentContainer(SiteNavDropdownContent, {
    navigationModule: graphql`
        fragment SiteNavDropdownContent_navigationModule on NavigationModule {
            ...SiteNavFullWidthDropdownContent_navigationModule
        }
    `,
});
